import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { APIV2_URL } from './constants';

interface Payload {
  listingId: number;
  startDate?: string;
  endDate?: string;
}

export default (makeCall: MakeCall) => (data: Payload) => {
  return makeCall<undefined>(
    'POST',
    `${APIV2_URL}/conversations/prospective-lead`,
    {
      data,
    },
  );
};
